import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { updateCurrentUserSetting } from '../../actions/coachActions'
import { gettingStartedSteps, currentGettingStartedStep, stepNoteKey } from './gettingStartedSteps'
import WelcomeVideoStep from './WelcomeVideoStep'
import CertificationStep from './CertificationStep'
import GettingStartedStepper from './GettingStartedStepper'
import GettingStartedHelp from './GettingStartedHelp'

import classes from './GettingStarted.module.scss'

const GettingStarted = ({ coach }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selection, setSelection] = useState(null)
  const [isSaving, setIsSaving] = useState(false)

  const steps = gettingStartedSteps(coach)
  const currentStep = currentGettingStartedStep(steps)
  const selectedKey = selection?.currentKey === currentStep.key ? selection.key : null
  const openStep = steps.find(step => step.key === selectedKey) || currentStep

  const saveSetting = (attributes) => {
    setIsSaving(true)
    dispatch(updateCurrentUserSetting(attributes)).unwrap()
      .catch(() => {
        toast.error(t('common.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT })
        setIsSaving(false)
      })
  }

  return (
    <section className={classes.card}>
      <header className={classNames('d-flex justify-content-between align-items-baseline', classes.header)}>
        <span className={classes.eyebrow}>
          {t('portal.gettingStarted.title', { current: steps.indexOf(openStep) + 1, total: steps.length })}
        </span>
        <span className={classes.meta}>{t(stepNoteKey(openStep))}</span>
      </header>

      {openStep.key === 'welcomeVideo' ? (
        <WelcomeVideoStep
          firstName={coach.first_name}
          done={openStep.done}
          isSaving={isSaving}
          onWatched={() => saveSetting({ welcome_video_watched_at: new Date().toISOString() })}
        />
      ) : (
        <CertificationStep
          certified={openStep.done && !openStep.skipped}
          skippable={!openStep.done}
          isSaving={isSaving}
          onSkip={() => saveSetting({ certification_skipped_at: new Date().toISOString() })}
        />
      )}

      <GettingStartedStepper steps={steps} openStepKey={openStep.key} onSelect={key => setSelection({ key, currentKey: currentStep.key })} />
      <GettingStartedHelp />
    </section>
  )
}

GettingStarted.propTypes = {
  coach: PropTypes.shape({ first_name: PropTypes.string }).isRequired,
}

export default GettingStarted
